// extracted by mini-css-extract-plugin
module.exports = {"title":"_48fcff","root":"_8aa6c1","titleContainer":"_edb1d0","cog":"_3fba31","content":"_92c47c"};